<div mat-dialog-title class="!text-base">{{title}}</div>
<mat-dialog-content class="pb-0">
  <form [formGroup]="newUserMasterForm" class="space-y-2">
    <mat-form-field class="w-full">
      <mat-label>Nombre</mat-label>
      <input matInput formControlName="name" autocomplete="off" type="text">
      <mat-error>Completa este campo.</mat-error>
    </mat-form-field>
    <mat-form-field class="w-full">
      <mat-label>Apellido</mat-label>
      <input matInput formControlName="lastName" autocomplete="off" type="text">
      <mat-error>Completa este campo.</mat-error>
    </mat-form-field>
    <mat-form-field class="w-full">
      <mat-label>Correo</mat-label>
      <input matInput formControlName="email" autocomplete="off" type="email">
      <mat-error *ngIf="newUserMasterForm.get('email').hasError('required')">
        Completa este campo.
      </mat-error>
      <mat-error *ngIf="newUserMasterForm.get('email').hasError('email')">
        Introduzca un correo válido.
      </mat-error>
    </mat-form-field>
    <div style="position: relative;">
      <mat-form-field class="w-full">
        <mat-label>Contraseña</mat-label>
        <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" autocomplete="off"/>
        <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword"
          [attr.aria-label]="'Mostrar contraseña'" [attr.aria-pressed]="!hidePassword">
          <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>

        <mat-error *ngIf="newUserMasterForm.get('password').hasError('required')">
          Completa este campo.
        </mat-error>
        <mat-error *ngIf="newUserMasterForm.get('password').hasError('pattern')">
          La contraseña no es segura.
        </mat-error>
      </mat-form-field>

      <!-- Icono de ayuda en la esquina superior derecha del campo -->
      <mat-icon 
        matTooltip="Debe contener: 
            - Números y Letras (Mayúsculas y Minúsculas)
            - Al menos un símbolo (@ $ ! % * # ? & ^ _ -)
            - Mínimo 6 caracteres"
        matTooltipClass="tooltip-pre"
        matTooltipShowDelay="200"
        matTooltipPosition="above"
        style="position: absolute; top: -28px; right: 2px; cursor: pointer;"
        >help</mat-icon>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-stroked-button mat-dialog-close color="primary" class="me-4">Cancelar</button>
  <adp-button-icon (clicked)="onSubmit()" color="primary" [disabled]="newUserMasterForm.invalid" [loading]="loader" label="Guardar"></adp-button-icon>
</mat-dialog-actions>
